import React from 'react'

type Props = {
   type?: 'button' | 'submit' | 'reset'
   variant?: 'primary' | 'outline' | 'text'
   size: 'large' | 'small'
   disabled?: boolean
   className?: string
   handleOnClick(event: React.MouseEvent<HTMLButtonElement>): void
   children?: React.ReactNode
}

const Button: React.FC<Props> = ({
   size,
   handleOnClick,
   children,
   className = '',
   disabled = false,
   variant = 'primary',
   type = 'button',
}) => {
   const paddingClass = size === 'large' ? 'py-4 px-20' : 'py-4 px-4 md:px-20'
   const layoutClass =
      variant === 'text'
         ? 'inline-flex items-center gap-2 normal-case font-normal'
         : `${paddingClass} uppercase block font-semibold rounded-card`

   const variantClasses =
      'outline-none text-[17px] active:shadow-[inset_0px_2px_2px_rgba(0,0,0,0.3)] disabled:bg-[#aaa] disabled:opacity-80 disabled:cursor-auto data-[variant=primary]:bg-lightBlue data-[variant=primary]:text-white data-[variant=primary]:border-0 data-[variant=primary]:hover:bg-lightBlueDarkVariation data-[variant=primary]:active:bg-lightBlueDarkestVariation data-[variant=outline]:bg-white data-[variant=outline]:text-lightBlue data-[variant=outline]:border data-[variant=outline]:border-dotted data-[variant=outline]:border-lightBlue data-[variant=outline]:hover:bg-lightBlueDarkVariation data-[variant=outline]:hover:text-white data-[variant=outline]:active:bg-lightBlueDarkestVariation data-[variant=outline]:active:text-white data-[variant=text]:bg-transparent data-[variant=text]:border-0 data-[variant=text]:p-[8px_12px] data-[variant=text]:text-inherit data-[variant=text]:hover:bg-gray1'

   return (
      <button
         type={type}
         data-variant={variant}
         onClick={handleOnClick}
         className={`${layoutClass} ${variantClasses} cursor-pointer focus:outline-none ${className}`}
         disabled={disabled}
      >
         {children}
      </button>
   )
}

export default Button
